import { ProductStatus } from 'features/product'

export const containsStatus = (status: ProductStatus, statuses: ProductStatus[]): boolean =>
  statuses.some((productStatus: ProductStatus) => productStatus === status)
